import { Injectable } from '@angular/core';
import { ITopicTagRates, ITimeFrame } from '../topic-tag-rates/topic-tag-rates';
import { Observable } from 'rxjs';
import { RestService } from 'src/app/shared/services/rest-service';

@Injectable({
  providedIn: 'root',
})
export class ReportingDataService {
  static readonly ENTITY_IDENTIFIER: string = 'reporting';
  private readonly BASE_REPORTING_ROUTE = `api/${ReportingDataService.ENTITY_IDENTIFIER}`;
  private readonly BUILD_HTTP_ROUTE = (...args) =>
    this.restService.BUILD_HTTP_ROUTE(this.BASE_REPORTING_ROUTE, ...args);

  constructor(private restService: RestService) {}

  getTopicTagRates(timeFrame?: ITimeFrame): Observable<ITopicTagRates[]> {
    const params = this.restService.buildHttpParamsObject({
      dateFrom: timeFrame?.dateFrom?.toDateString() ?? '',
      dateTo: timeFrame?.dateTo?.toDateString() ?? '',
    });
    return this.restService.get$<ITopicTagRates[]>(
      this.BUILD_HTTP_ROUTE('topictagrates'),
      { params },
    );
  }
}
